export var loyalty_Points = [
	// { 'id' : '2', 'discription':"ZuluTrade subscription for 1 month", 'points':'250', 'image':'zulutradeLogo.png'},
	{ 'id' : '3', 'detal_id' : '8', 'discription':"Basic VPS for 1 month", 'points':'250', 'image':'vpsPackeg.svg'},
	{ 'id' : '4', 'detal_id' : '10', 'discription':"Premium VPS for 1 month", 'points':'500', 'image':'priumSvt.svg'},
	{ 'id' : '5', 'detal_id' : '11', 'discription':"Standard VPS for 3 months", 'points':'1000',  'image':'vpsStanded.svg'},
	// { 'id' : '6', 'discription':"Forex training with our market analyst", 'points':'2000', 'image':'Investment-data-bro.svg'},
	// { 'id' : '7', 'discription':"1 year digital subscription to Bloomberg news", 'points':'3000', 'image':'Bloomberg_News_logo.png'},
	{ 'id' : '8', 'discription':"A smart watch", 'points':'5000',  'image':'pple-watch.jpg'},
	{ 'id' : '9', 'discription':"An iPad or a laptop", 'points':'10000', 'image':'apple-ipad.jpg'},
	{ 'id' : '10', 'discription':"A smartphone", 'points':'12000', 'image':'traderPhone.png'},
	// { 'id' : '1', 'discription':"$750 gift card for the Trader's Marketplace", 'points':'750', 'image':'P2P-bro.svg'}
]


//////////////////
// WEBPACK FOOTER
// ./static/fxView/js/loyalty_Points.js
// module id = null
// module chunks = 